import React from "react";
import { Link } from "react-router-dom";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";
import { useLanguage } from "../../../hooks/use-language";

export const FooterLegalLinks = () => {
	const lang = useLanguage();
	const footerTexts = useTranslationsById({ mainSectionName: "footer", language: lang });

	return (
		<nav className="footer-legal-links my-4 my-lg-0" aria-label="Enlaces legales del footer">
			<Link className="focusable-secondary" to="/politica-de-soporte">
				{footerTexts.getText({ id: "legal.support", defaultText: "Política de soporte" })}
			</Link>
			<Link className="focusable-secondary" to="/terminos-y-condiciones">
				{footerTexts.getText({
					id: "legal.terms",
					defaultText: "Términos y condiciones",
				})}
			</Link>
			<Link className="focusable-secondary" to="/politica-de-privacidad">
				{footerTexts.getText({ id: "legal.privacy", defaultText: "Privacidad de Datos" })}
			</Link>
		</nav>
	);
};
